import { getPhysicalInfo } from "./getPhysicalInfo";

export const globalRegisterParamsFormat = (data) => {
    return Promise.all([
        getPhysicalInfo(data),
    ])
}